import Vue from 'vue';
import axios from 'axios';

export default {
    provide(offset) {
        return axios.get(window.applicationSettings.apiEndpoint + '/activitylog/list/'+offset)
            .then(response => response.data)
            .catch(error => Promise.reject(error.response))
    }
}